import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "panel-content-container" }
const _hoisted_2 = {
  key: 1,
  class: "wallet-panel-multilevel"
}

import { computed, ref } from 'vue';
import WalletData from '@/views/layout/wallet/WalletData.vue';
import DisconnectConfirmation from './DisconnectConfirmation.vue';
import { useWallet } from '@/store/modules/wallet/useWallet';
import { useStore } from 'vuex';
import Icon from '@/components/icon/Icon.vue';
import { fixOverlayPosition, useUtils } from '@/composables/utils/useUtils';
import WalletConnect from '@/views/layout/wallet/WalletConnect.vue';
import { HEADER_HEIGHT } from '@/constants/LAYOUT_PARAMS';


export default /*#__PURE__*/_defineComponent({
  __name: 'Wallet',
  setup(__props) {

const { walletState, disconnect, getWalletName } = useWallet();
const { state } = useStore();
const { textEllipsis } = useUtils();

const walletPanel = ref();
const isDisconnectConfirmation = ref(false);

const isWalletError = computed(() => walletState.isInjected && !walletState.isNetworkSupported);
const walletButtonLabel = computed(() => textEllipsis(getWalletName, 6, 4));

const toggleWalletPanel = event => {
  walletPanel.value.toggle(event);
};

const onOpenDisconnect = () => {
  isDisconnectConfirmation.value = true;
};
const onCloseDisconnect = () => {
  isDisconnectConfirmation.value = false;
};
const onConfirmDisconnect = () => {
  disconnect();
  onCloseDisconnect();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_unref(walletState).isInjected)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_unref(state).layout.isMobile)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "button-base",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleWalletPanel($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, {
                  name: _unref(isWalletError) ? 'danger' : 'wallet',
                  size: "20",
                  class: _normalizeClass(["mr-s1", _unref(isWalletError) ? 'text-error' : 'text-gray'])
                }, null, 8, ["name", "class"]),
                _createElementVNode("span", {
                  class: _normalizeClass({ 'text-error': _unref(isWalletError) })
                }, _toDisplayString(_unref(walletButtonLabel)), 3)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_OverlayPanel, {
          ref_key: "walletPanel",
          ref: walletPanel,
          class: "wallet-panel-multilevel",
          onShow: _cache[1] || (_cache[1] = ($event: any) => (_unref(fixOverlayPosition)('.wallet-panel-multilevel', _unref(HEADER_HEIGHT))))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(WalletData, { onDisconnectWallet: onOpenDisconnect })
            ])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_Dialog, {
          visible: isDisconnectConfirmation.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((isDisconnectConfirmation).value = $event)),
          modal: true,
          showHeader: false,
          dismissableMask: ""
        }, {
          default: _withCtx(() => [
            _createVNode(DisconnectConfirmation, {
              cancel: onCloseDisconnect,
              confirm: onConfirmDisconnect
            })
          ]),
          _: 1
        }, 8, ["visible"]),
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(WalletData, { onDisconnectWallet: onOpenDisconnect })
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock(WalletConnect, {
        key: 1,
        "is-header-button": !_unref(state).layout.isMobile
      }, null, 8, ["is-header-button"]))
}
}

})